export default "__VITE_ASSET__a37f5d83__"